import { DateTime } from 'luxon';
import type { LeagueGames } from '@library/types/games';
import { formatWithTimezoneChange } from '@library/utils/dateTime';
import { uniq } from 'ramda';

export const getLeagueGames = ({
  leagueGames,
  fromDateTime,
  toDateTime
}: {
  leagueGames: LeagueGames;
  fromDateTime: string;
  toDateTime: string;
}): LeagueGames => {
  const DATE_FORMAT = 'yyyyLLdd';

  const fromDate = formatWithTimezoneChange(
    DateTime.fromISO(fromDateTime),
    DATE_FORMAT
  );
  const numericFromDate = Number(fromDate);
  const toDate = formatWithTimezoneChange(
    DateTime.fromISO(toDateTime),
    DATE_FORMAT
  );
  const numericToDate = Number(toDate);

  const games = leagueGames.filter(({ date_time }) => {
    const EDTStartDate = formatWithTimezoneChange(
      DateTime.fromISO(date_time),
      DATE_FORMAT
    );
    const numericEDTStartDate = Number(EDTStartDate);

    return (
      numericEDTStartDate >= numericFromDate &&
      numericEDTStartDate <= numericToDate
    );
  });
  return uniq(games);
};
